import React from 'react';
interface DatePickerProps {
  label?: string;
  value: string;
  onChange: (value: string) => void;
  error?: string;
  min?: string;
  max?: string;
  required?: boolean;
}
export function DatePicker({
  label,
  value,
  onChange,
  error,
  min,
  max,
  required
}: DatePickerProps) {
  return <div className="w-full" data-id="element-246">
      {label && <label className="block text-sm font-medium text-gray-700 mb-1.5" data-id="element-247">
          {label}
          {required && <span className="text-red-500 ml-1" data-id="element-248">*</span>}
        </label>}
      <input type="date" value={value} onChange={e => onChange(e.target.value)} min={min} max={max} className={`w-full px-3 py-2 border rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent ${error ? 'border-red-500' : 'border-gray-300'}`} data-id="element-249" />
      {error && <p className="mt-1 text-sm text-red-600" data-id="element-250">{error}</p>}
    </div>;
}